
/* src/components/block/broadcastingChannelManagment/BroadcastingChannelRow.tsx */

import   React                                  from 'react';

import   classNames            from 'classnames';
import   Toggle                from '../../widget/inputs/Toggle';
import   styles                from './BroadcastingChannelRow.module.scss';
import { BroadcastingChannel } from '../../../dataTypes/broadcastingManagment/types';
import { Product             } from '../../../dataTypes/productManagment/types';
import   Icon                  from '../../widget/images/Icon';
import { WWW_URLS }            from '../../../backendServices/urls';
import { broadcastingChannelIsPaid } from '../../../dataTypes/broadcastingManagment/utils';


// ── Présentation de l'état d'une chaîne ─────────────────────────────────────
// `active` seul ne dit pas tout : l'activation provisionne l'infra (container,
// MediaMTX, HAProxy) et passe par des états transitoires, et peut finir en erreur.
// Une pastille verte sur le seul booléen restait donc verte après un échec.
// Couleurs alignées sur les badges du dashboard de la chaîne
// (BroadcastingChannelDashboard.module.scss:74-84).
type ChannelStatusPresentation = { color: string; title: string };

const CHANNEL_STATUS_PRESENTATION: Record<BroadcastingChannel['channelStatus'], ChannelStatusPresentation> = {
  active:                  { color: '#25C400', title: 'Chaîne active' },
  inactive:                { color: '#C30000', title: 'Chaîne inactive' },
  restricted:              { color: '#8b5cf6', title: 'Active en privé — invisible du public' },
  activating:              { color: '#f59e0b', title: 'Activation en cours…' },
  deactivating:            { color: '#f59e0b', title: 'Désactivation en cours…' },
  activating_restricted:   { color: '#d946ef', title: "Préparation de l'enregistrement privé…" },
  deactivating_restricted: { color: '#d946ef', title: "Démontage de l'enregistrement privé…" },
  error:                   { color: '#ef4444', title: "Erreur d'activation — réessayer depuis la fiche" },
};

interface BroadcastingChannelRowProps {
  broadcastingChannel : BroadcastingChannel;
  index               : number;
  onEdit              : (index: number) => void;
  onDelete            : (id: number) => void;
  productArray        : Product []
}

export const BroadcastingChannelRow = ({ broadcastingChannel ,
                                         index               ,
                                         onEdit              ,
                                         onDelete            ,
										 productArray        }: BroadcastingChannelRowProps) => {

  // Statut inconnu (valeur backend inattendue) : on retombe sur le booléen.
  const statusPresentation = CHANNEL_STATUS_PRESENTATION[broadcastingChannel.channelStatus]
                          ?? (broadcastingChannel.active
                                ? CHANNEL_STATUS_PRESENTATION.active
                                : CHANNEL_STATUS_PRESENTATION.inactive);

  return (
    <div className={classNames(styles.row)}>
      <div className = { classNames ( styles.column_1 , styles.standard ) } >
		{
		 broadcastingChannel.logoImageFile !== '' &&
         <img className = {styles.thumbnail}
              src       = {`${WWW_URLS.MediaServer}${broadcastingChannel.publicRef}/images/thumbnail.webp`}
              alt       = "Logo" />	 
        }			  
      </div>      <div className = { classNames ( styles.column_2 , styles.standard ) } >
        {broadcastingChannel.name}
      </div>

<div className={classNames(styles.column_3, styles.standard)}>
  <div className={styles.iconButton} onClick={() => onEdit(index)}>
    <Icon name       = "pen"
          color      = "var(--color-Icon-FG)"
          hoverColor = "var(--color-Icon-hover-FG)" 
          width      = {20}
          height     = {20}/>
  </div>
  <div className={styles.iconButton} onClick={() => onDelete(broadcastingChannel.id)}>
    <Icon name       = "trashCan"
          color      = "var(--color-Icon-FG)"
          hoverColor = "var(--color-Icon-hover-FG)"
          width      = {20}
          height     = {20} />
  </div>
</div>

      <div className = { classNames ( styles.column_4 , styles.standard ) } >
	    <span>{broadcastingChannel.mode === 'Delayed' ? 'Diffusion' : 'Direct'}</span>
      </div>
      {/* Puce et non interrupteur : la couleur vient de channelStatus et non du seul
          booléen, elle porte donc aussi les états transitoires et l'échec d'activation.

          Elle AFFICHE, elle ne commande pas : la variante `bullet` de Toggle ne câble ni
          clic ni readOnly, et l'activation d'une chaîne se fait depuis sa fiche
          (BroadcastingChannelSheet, handleActiveToggle), seul endroit qui gère le quota
          saturé, le préavis d'arrêt d'enregistrement et la revérification avant rollback.
          Ne pas y remettre un onChange en croyant réparer un oubli. */}
      <div className = { classNames ( styles.column_5 , styles.standard ) }
           title     = { statusPresentation.title } >
        <Toggle checked      = {broadcastingChannel.active}
                form         = "bullet"
                fillColorOn  = {statusPresentation.color}
                fillColorOff = {statusPresentation.color} />
      </div>
      <div className = { classNames ( styles.column_6 , styles.standard ) } >
        <div className={classNames(styles.statusDot, broadcastingChannelIsPaid (broadcastingChannel, productArray) ? styles.statusDotOk : styles.statusDotNok)}>
      		<Icon name="disk" color={ broadcastingChannelIsPaid (broadcastingChannel, productArray) ?"var(--color-OK)":"var(--color-NOK)"} width={20} height={16} hoverable={false} clickable={false}/>
        </div>
      </div>
      <div className = { classNames ( styles.column_7 , styles.standard ) } >
        <div className={classNames(styles.statusDot, broadcastingChannel.publicPortal ? styles.statusDotOk : styles.statusDotNok)}>
	        <Icon name="disk" color={broadcastingChannel.publicPortal?"var(--color-OK)":"var(--color-NOK)"} width={20} height={16} hoverable={false} clickable={false}/>
        </div>
      </div>
    </div>
  );
};

export default BroadcastingChannelRow;
